import { faCaretRight, faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Row, theme } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clinicIcon from '../../../../../assets/icons/clinic.png'
import onlineMeetingIcon from '../../../../../assets/icons/online-meeting.png'
import CoreEnums from '../../../../../core/utils/enums'
import coreReducer from '../../../../../core/utils/reducer'
import { checkSubscriptions } from '../../../../Subscriptions/utils/utils'
import PatClinicConsultBooking from '../../../Clinic Consultation'
// import VirtualConsultationMobile from '../../../Virtual Consultation/MobileNew' // Old flow (unused)
import '../styling/MobileBookingShortcut.css'
import SearchEngineWithProviders from '../../../../Search Engine'

const MobBookingShortcuts = ({ showSOS }) => {
  const dispatch = useDispatch()
  const entityState = useSelector((state) => state.core.entity)
  const authState = useSelector((state) => state.auth)

  // Get user's first name for personalized greeting
  const userName = authState?.agiliteUser?.firstName || ''

  const containerStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }

  const buttonStyle = {
    width: '100%',
    height: '60px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    fontSize: '16px',
    fontWeight: '400',
    border: '1px solid #E0E0E0',
    color: '#000000',
    background: '#FFFFFF',
    position: 'relative',
    padding: '0 20px',
    lineHeight: '1.2',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  }

  const enhancedButtonStyle = {
    ...buttonStyle,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: 'none',
    transition: 'all 0.3s ease'
  }

  const virtualButtonStyle = {
    ...enhancedButtonStyle,
    background: 'linear-gradient(to right, #f7fbff, #ffffff)',
    borderLeft: '3px solid #10B2E1'
  }

  const clinicButtonStyle = {
    ...enhancedButtonStyle,
    background: 'linear-gradient(to right, #fff9fb, #ffffff)',
    borderLeft: '3px solid #E91E63'
  }

  const sosButtonStyle = {
    ...buttonStyle,
    border: '1px solid #E91E63',
    color: '#E91E63',
    background: '#FFFFFF'
  }

  const handleClinicBooking = (isReceptionBooking, dispatcher) => {
    dispatcher(
      coreReducer.actions.addTab({
        key: `${CoreEnums.tabKeys.MY_BOOKINGS}_new_clinic_booking`,
        closable: true,
        label: 'New Clinic Booking',
        children: <SearchEngineWithProviders />
      })
    )
  }
  const { token } = theme.useToken()
  return (
    <Row>
      <Col span={24} style={{ marginBottom: 16 }}>
        <h2
          style={{
            textAlign: 'left',
            fontSize: 18,
            color: '#000000',
            fontWeight: 500,
            margin: 0,
            padding: '0 0 0 4px'
          }}
        >
          {userName ? `Hi ${userName}, need a doctor?` : 'Need a doctor?'}
        </h2>
      </Col>
      <Col span={24}>
        <div style={containerStyle}>
          <Button
            style={{
              ...virtualButtonStyle,
              display: 'flex',
              alignItems: 'center',
              opacity: !entityState.virtualConsultations?.enabled ? 0.7 : 1,
              color: !entityState.virtualConsultations?.enabled ? '#A0A0A0' : '#000000'
            }}
            onClick={() =>
              dispatch(
                coreReducer.actions.addTab({
                  key: 'VIRTUAL_CONSULTATION_MOBILE_MAIN_NEW',
                  closable: true,
                  label: 'Virtual Consultation',
                  children: <SearchEngineWithProviders isVirtualVisit={true} />
                })
              )
            }
            type='default'
            disabled={!entityState.virtualConsultations?.enabled}
            icon={
              <div
                style={{
                  width: 32,
                  height: 32,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  src={onlineMeetingIcon}
                  alt='Virtual Consult'
                  style={{
                    width: 32,
                    height: 32,
                    opacity: !entityState.virtualConsultations?.enabled ? 0.5 : 1,
                    filter: !entityState.virtualConsultations?.enabled
                      ? 'grayscale(100%)'
                      : 'brightness(0) saturate(100%) invert(45%) sepia(99%) saturate(1783%) hue-rotate(166deg) brightness(95%) contrast(101%)'
                  }}
                />
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
              <span style={{ fontSize: 16, fontWeight: 400 }}>Schedule a Virtual Consult</span>
              <span style={{ fontSize: 12, color: '#757575', fontWeight: 400 }}>See a doctor online</span>
            </div>
            <FontAwesomeIcon icon={faCaretRight} style={{ marginLeft: 'auto', color: '#757575' }} />
          </Button>

          <Button
            style={{
              ...clinicButtonStyle,
              display: 'flex',
              alignItems: 'center'
            }}
            onClick={() => handleClinicBooking(false, dispatch)}
            type='default'
            icon={
              <div
                style={{
                  width: 32,
                  height: 32,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  src={clinicIcon}
                  alt='In-Person Consult'
                  style={{
                    width: 32,
                    height: 32,
                    filter:
                      'brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(7466%) hue-rotate(328deg) brightness(95%) contrast(96%)'
                  }}
                />
              </div>
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
              <span style={{ fontSize: 16, fontWeight: 400 }}>Schedule an In-Person Consult</span>
              <span style={{ fontSize: 12, color: '#757575', fontWeight: 400 }}>Visit a clinic near you</span>
            </div>
            <FontAwesomeIcon icon={faCaretRight} style={{ marginLeft: 'auto', color: '#757575' }} />
          </Button>

          {entityState.vitalLink?.enabled && showSOS && (
            <Button
              style={sosButtonStyle}
              onClick={() => window.open('tel:+27')}
              type='default'
              disabled={!checkSubscriptions('vitalLink')}
              icon={<FontAwesomeIcon icon={faWarning} style={{ fontSize: 20, color: '#E91E63' }} />}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
                <span style={{ fontSize: 16, fontWeight: 400 }}>Emergency Assistance</span>
                <span style={{ fontSize: 12, color: '#757575', fontWeight: 400 }}>Get immediate help</span>
              </div>
              <FontAwesomeIcon icon={faCaretRight} style={{ marginLeft: 'auto', color: '#757575' }} />
            </Button>
          )}
        </div>
      </Col>
    </Row>
  )
}

export default MobBookingShortcuts
